var map = {
	"./attach-files.svg": "1b56",
	"./btn-email.svg": "69d2",
	"./btn-whatsapp.svg": "1962",
	"./c-3-email.svg": "155f",
	"./c-3-whatsapp.svg": "806c",
	"./chat-attach.svg": "52c9",
	"./chat-icon.svg": "5d65",
	"./chat-send-active.svg": "3531",
	"./chat-with-us.svg": "739b",
	"./clock.svg": "755b",
	"./close-circle.svg": "1cfc",
	"./comment-yes-active.svg": "8896",
	"./comment-yes.svg": "39d1",
	"./delete.svg": "0d45",
	"./direction-right-white.svg": "5eb9",
	"./direction-right.svg": "85ecf",
	"./email.svg": "43be",
	"./emoji.svg": "9325",
	"./error.svg": "28c3",
	"./exclamation.svg": "177c",
	"./home-email.svg": "a65b",
	"./home-whatsapp.svg": "b5a8",
	"./infoListClose.svg": "ad6e",
	"./infoListOpen.svg": "327b",
	"./left-arrow.svg": "6d4b",
	"./logo.svg": "5b1c",
	"./logobar.svg": "121b",
	"./order-search-icon.svg": "6020",
	"./order-track-icon.svg": "b4bf",
	"./refresh.svg": "53fa",
	"./right-arrow.svg": "c686",
	"./search-icon.svg": "7669",
	"./search-notfound-icon.svg": "9f76",
	"./select-down.svg": "d64c",
	"./select-up.svg": "69fe",
	"./send copy.svg": "3b7a",
	"./send.svg": "5b6e",
	"./tick.svg": "812c",
	"./whatsapp.svg": "7583",
	"./willdesk.svg": "e6ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0057";